import React from "react";
import { TFunction } from "react-i18next";

interface Props {
  t: TFunction<"ns1">;
}

const MainTextTop: React.FC<Props> = ({ t }: Props) => {
  return (
    <>
      <h1>{t("mobile_clothes_intake")}</h1>
      <p>{t("we_serve_immigrants")}</p>
      <p>
        {t("want_to_donate")}{" "}
        <a href="mailto: mobileclothes@bmccs.org">{t("send_email")}</a>
        {t("with_name_and_phone")}
      </p>

      <p>
        {t("Want to donate money? ")}
        <a
          href="https://bethelmennonite.ccbchurch.com/goto/giving"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("Please go here")}
        </a>
        {t(" and select mobile clothes!")}
      </p>
    </>
  );
};

export default MainTextTop;
